import { useState } from 'react';

import { getContext } from '@/context';
import checkIsAuthorized from '@/utils/user/isAuthorized';
import useMount from './useMount';

/**
 * Reactive auth state. Delegates the "signed in?" decision to the canonical
 * `isAuthorized` util (auth `id != null`, or a present Authorization header as
 * an earlier-arriving fallback), and re-derives it whenever `general.auth`
 * changes.
 */
const useAuth = () => {
  const [isAuthorized, setIsAuthorized] = useState(checkIsAuthorized);

  useMount(() => {
    const unSubscribe = getContext().general.auth.subscribe(() => {
      setIsAuthorized(checkIsAuthorized());
    });

    return () => {
      unSubscribe?.();
    };
  });

  return { isAuthorized };
};

export default useAuth;
